/**
 * @description Type guard function to check if an unknown item is a plain object (not null, not an array).
 * This function is crucial for determining if an item is suitable for object merging or property iteration.
 *
 * @param {unknown} item The item to check.
 * @returns {item is Record<string, any>} Returns true if the item is a non-null object and not an array.
 * @example
 * // Usage:
 * const myObj = { a: 1 };
 * if (isObject(myObj)) {
 * console.log('It is an object');
 * }
 */
export const isObject = (item) => !isNullish(item) && typeof item === 'object' && !Array.isArray(item);
export const isNullish = (item) => item === null || item === undefined;
export const isNil = isNullish;
export const isPlainObject = (obj) => typeof obj === 'object' && obj !== null && obj.constructor === Object && Object.prototype.toString.call(obj) === '[object Object]';
//# sourceMappingURL=guards.js.map